import React from 'react';
import { graphql, navigate } from 'gatsby';

import { CONTENTFUL_SLUGS } from '../../../shared/constants';
import { LeadType } from '../../../shared/constants/Tracking.constants';
import { IContactForm } from '../../../types/shared';

import { getInternalLink } from '../../../utils/generic';
import SEO from '../../utils/SEO';

import { getRecaptchaSiteKey } from '../../../services/re-captcha.service';
import BaseLayout from '../../layouts/BaseLayout';
import ContactForm from '../../organisms/contact-form/ContactForm';
import { GenericPageProps } from '../generic-page/GenericPage.types';

const ContactFormPage = ({ data, pageContext }: GenericPageProps) => {
  const pageData = data?.contentfulPageGeneric;
  const contactForm = pageData.body[0];

  const onCloseHandler = () => {
    navigate(
      pageData.parentPage
        ? `/${getInternalLink(pageData.parentPage)}`
        : (pageData.externalParentPage.externalUrl as string)
    );
  };

  return (
    <BaseLayout layoutType={pageData.layoutType}>
      <SEO
        title={pageData.metadataTitle}
        description={pageData.metadataDescription?.metadataDescription}
        lang={pageData?.metadataLocale}
        image={
          pageData.metadataImage.gatsbyImageData?.images?.fallback?.src ||
          pageData.metadataImage.file?.url
        }
        noIndex={pageData?.metadataNoIndex}
      />
      <ContactForm
        title={(contactForm as IContactForm).title}
        name={contactForm.name}
        subtitle={
          (pageData.parentPage?.name as string) ||
          pageData?.externalParentPage?.label ||
          ''
        }
        parentPage={pageData.parentPage}
        externalParentPage={pageData.externalParentPage}
        form={contactForm as IContactForm}
        trackingName={(contactForm as IContactForm)?.trackingName}
        successCards={(contactForm as IContactForm)?.successBody}
        pageContext={pageContext}
        tags={pageData.tags}
        onClose={onCloseHandler}
        formTrackingType={
          pageData.slug === CONTENTFUL_SLUGS.unsubscribeCommunications
            ? LeadType.LEAD_SOFT
            : LeadType.LEAD_HARD
        }
      />
    </BaseLayout>
  );
};

export const data = graphql`
  query contactForm($slug: String) {
    contentfulPageGeneric(slug: { eq: $slug }) {
      id
      pageName
      layoutType
      externalParentPage {
        ...Link
      }
      ...ParentPageGeneric
      tags {
        id
        name
        value
        type
      }
      metadataDescription {
        metadataDescription
      }
      metadataImage {
        file {
          url
        }
        gatsbyImageData(layout: FULL_WIDTH)
      }
      metadataNoIndex
      metadataTitle
      header {
        ...Card
      }
      headerCards {
        ...Card
      }
      showAnchorLinks
      body {
        ...ContactForm
      }
      footer {
        ... on ContentfulCompCard {
          ...Card
        }
        ... on ContentfulCompCardWrapper {
          ...CardWrapper
        }
      }
    }
  }
`;

export default ContactFormPage;

export function Head() {
  return (
    <script
      async
      src={`https://www.google.com/recaptcha/api.js?render=${getRecaptchaSiteKey()}`}
    />
  );
}
